import React from 'react';
import { RoutineLimits, RoutineSpec } from '../servicesShared';
import { DirtySetter, SectionHeader } from './editorShared';
import { EditableSetupQuestion, SetupQuestionsEditor } from './SetupQuestionsEditor';
import RoutinesTab from './RoutinesTab';

/**
 * Setup: how a job starts for a customer (what it must settle with them
 * first) and when it wakes on its own afterwards (routines). All of it is
 * part of the versioned definition.
 */
export const SetupTab: React.FC<{
    setup: EditableSetupQuestion[];
    onSetupChange: DirtySetter<EditableSetupQuestion[]>;
    routines: RoutineSpec[];
    onRoutinesChange: DirtySetter<RoutineSpec[]>;
    limits: RoutineLimits;
    onLimitsChange: DirtySetter<RoutineLimits>;
}> = ({ setup, onSetupChange, routines, onRoutinesChange, limits, onLimitsChange }) => (
    <>
        <section className="mb-10">
            <SectionHeader
                title="Setup questions"
                description="What the job must settle with the customer before it is live. Asked in conversation on the first wake; answers are stored on the job."
            />
            <SetupQuestionsEditor items={setup} onChange={onSetupChange} />
        </section>
        <RoutinesTab routines={routines} onRoutinesChange={onRoutinesChange} limits={limits} onLimitsChange={onLimitsChange} />
    </>
);

export default SetupTab;
